/**
 * Lockstep Platform SDK for TypeScript
 *
 * (c) 2021-2023 Lockstep, Inc.
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 *
 * @author     Lockstep Network <support@lockstep.io>
 * @copyright  2021-2023 Lockstep, Inc.
 * @link       https://github.com/Lockstep-Network/lockstep-sdk-typescript
 */
export class MagicLinksClient {
    /**
     * Internal constructor for this client library
     */
    constructor(client) {
        this.client = client;
    }
    /**
     * Retrieves the Magic Link specified by this unique identifier, optionally including nested data sets.
     *
     * @param id The id of the Magic Link
     * @param include To fetch additional data on this object, specify the list of elements to retrieve. Available collections: User
     */
    retrieveMagicLink(id, include) {
        const url = `/api/v1/useraccounts/magic-links/${id}`;
        const options = {
            params: {
                include,
            },
        };
        return this.client.request("get", url, options, null);
    }
    /**
     * Revokes the magic link with the specified id so it cannot be used to call the API.
     *
     * Revocation will be received by all servers within five minutes of revocation. API calls made using this magic link after the revocation will fail. A revoked magic link cannot be un-revoked.
     *
     * @param id The unique Lockstep Platform ID number of this magic link
     */
    revokeMagicLink(id) {
        const url = `/api/v1/useraccounts/magic-links/${id}`;
        return this.client.request("delete", url, null, null);
    }
    /**
     * Queries Magic Links for this account using the specified filtering, sorting, nested fetch, and pagination rules requested.
     *
     * @param filter The filter for this query. See [Searchlight Query Language](https://developer.lockstep.io/docs/querying-with-searchlight)
     * @param include To fetch additional data on this object, specify the list of elements to retrieve. Available collections: User
     * @param order The sort order for the results, in the [Searchlight order syntax](https://github.com/tspence/csharp-searchlight).
     * @param pageSize The page size for results (default 250, maximum of 500)
     * @param pageNumber The page number for results (default 0)
     */
    queryMagicLinks(filter, include, order, pageSize, pageNumber) {
        const url = `/api/v1/useraccounts/magic-links/query`;
        const options = {
            params: {
                filter,
                include,
                order,
                pageSize,
                pageNumber,
            },
        };
        return this.client.request("get", url, options, null);
    }
}
//# sourceMappingURL=MagicLinksClient.js.map